import * as Tabs from '@radix-ui/react-tabs'
import clsx from 'clsx'
import type { Dayjs } from 'dayjs'

import { ContentWeek } from '@/components/NextWeekMenu/ContentWeek'
import useNextWeekMenu from '@/hooks/useNextWeekMenu'
import type { GroupedMenu } from '@/models/menu'

import './next-week-menu-tabs.scss'
import type React from 'react'

export interface MenuTabsItem {
  date: Dayjs
  name: string
  label: string
  menu: GroupedMenu[]
}

const classes = ['nwm-items', 'type-label']

export const NextWeekMenuPage: React.FC = () => {
  const {
    weekMenuTabItems,
    isLoading,
    isMenuLoading,
    fetchWeekMenu,
    defaultWeekIndex,
  } = useNextWeekMenu()

  if (isLoading) {
    return <div>Loading...</div>
  }

  const handleTabChange = (value: string) => {
    const dateValue = weekMenuTabItems?.filter((item) => item.name === value)
    if (!dateValue || dateValue?.[0].menu.length) return
    fetchWeekMenu(dateValue?.[0].date)
  }

  return (
    <>
      <Tabs.Root
        className="tabs__center"
        defaultValue={weekMenuTabItems?.[defaultWeekIndex].name}
        onValueChange={handleTabChange}
      >
        <Tabs.List className={clsx(classes)}>
          {weekMenuTabItems?.map((item) => (
            <Tabs.Trigger
              className="nwm-items__item"
              key={item.name}
              value={item.name}
            >
              <p className="nwm-items__link">{item.label}</p>
            </Tabs.Trigger>
          ))}
        </Tabs.List>
        {weekMenuTabItems?.map((item) => (
          <Tabs.Content
            value={item.name}
            key={item.name}
            className="tabs__component-container"
          >
            <div className="tabs__component-container__weeks">
              {isMenuLoading ? (
                <div>Loading...</div>
              ) : (
                <ContentWeek weekData={item} />
              )}
            </div>
          </Tabs.Content>
        ))}
      </Tabs.Root>
    </>
  )
}
